// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../lastDayOfMonth/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var lastDayOfMonth = convertToFP(fn, 1);
export default lastDayOfMonth;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/lastDayOfMonth/index.js
// module id = 951
// module chunks = 0